<script setup>
import { ref, computed, onBeforeMount, watch, defineEmits, defineExpose, watchEffect } from 'vue'
import { Referencias } from '@/stores/referencias'

import { useAlert } from '@/composables/useAlert'
import { usePrimeVueConfig } from '@/composables/usePrimeVue'
import { formatDateView } from '@/utils/date-fns'

import ToggleButton from 'primevue/togglebutton'

const { ActionObterReferenciasPeriodo, ActionObterReferenciaSubPeriodos, $state } = Referencias()

const { alertError } = useAlert()
const { defineLocale } = usePrimeVueConfig()

const active = ref(false)
const loadingSubperiodo = ref(true)

const filtroReferencia = ref(true)
const filtroPeriodo = ref(false)

const referencia = ref(null)
const subPeriodo = ref(null)
const datainicio = ref(null)
const dataFim = ref(null)
const subperiodoinicio = ref(null)
const subperiodoFim = ref(null)

const subPeriodoSelecionado = (event) => {
  const datas = event.value.descricao.split(' até ')
  subperiodoinicio.value = datas[0]
  subperiodoFim.value = datas[1]
}

const referenciaSelecionada = async (event) => {
  try {
    let referencia
    if (event.id) referencia = event
    else referencia = event.value

    datainicio.value = referencia.dataInicio
    dataFim.value = referencia.dataFim
    subperiodoinicio.value = null
    subperiodoFim.value = null

    await ActionObterReferenciaSubPeriodos(referencia.id)
  } catch (error) {
    alertError('Não foi possível carregar os sub períodos,  atualize a página!')
  } finally {
    loadingSubperiodo.value = false
  }
}

const iniciar = async () => {
  try {
    active.value = true
    defineLocale()
    await ActionObterReferenciasPeriodo({
      pagina: 1,
      limite: 1000,
      ordenar: 'nome'
    })

    const atualReferencia = dropReferencias.value.items.find((ref) => ref.atual == true)
    referenciaSelecionada(atualReferencia)
    referencia.value = atualReferencia
  } catch (error) {
    alertError('Não foi possível carregar as referências,  atualize a página!')
  } finally {
    active.value = false
  }
}

const dropReferencias = computed(() => $state.referenciasPeriodo)

const dropPeriodos = computed(() => $state.referenciaSubPeriodos)

const payloadPeriodo = computed(() => {
  console.log('subperiodoinicio.value', subperiodoinicio.value)
  return {
    dataInicio: subperiodoinicio.value
      ? subperiodoinicio.value
      : datainicio.value instanceof Date
      ? formatDateView(datainicio.value)
      : datainicio.value,
    dataFim: subperiodoFim.value ? subperiodoFim.value : dataFim.value instanceof Date ? formatDateView(dataFim.value) : dataFim.value,
    subPeriodoid: subPeriodo.value?.id
  }
})

const emit = defineEmits(['payloadPeriodo'])

watchEffect(() => emit('payloadPeriodo', payloadPeriodo.value))

watch(
  () => filtroPeriodo.value,
  () => {
    if (filtroPeriodo.value === true) filtroReferencia.value = !filtroReferencia.value
  }
)

watch(
  () => filtroReferencia.value,
  () => {
    if (filtroReferencia.value === true) filtroPeriodo.value = !filtroPeriodo.value
    subperiodoinicio.value = null
    subperiodoFim.value = null
    subPeriodo.value = null
  }
)

defineExpose({
  referencia
})

watchEffect(() => iniciar())
</script>
<template>
  <div class="container-filtro-periodo">
    <Progress :active="active" />
    <Divider align="left">
      <div class="inline-flex align-items-center">
        <i class="pi pi-shield mr-2"></i>
        Período
      </div>
    </Divider>
    <div class="block-perido-filtro">
      <div class="troggles-periodo">
        <div class="field">
          <ToggleButton v-model="filtroReferencia" onLabel="Referência" offLabel="Referência" />
        </div>
        <div class="field">
          <ToggleButton v-model="filtroPeriodo" onLabel="Período" offLabel="Período" />
        </div>
      </div>
      <div class="datas-periodo" v-if="filtroPeriodo">
        <div class="field">
          <label for="dataInicio">Data inicio</label>

          <Calendar id="dataInicio" v-model="datainicio" :manualInput="false" class="p-inputMesAno" dateFormat="dd/mm/yy" showIcon />
        </div>
        <div class="field">
          <label for="dataFim">Data fim</label>

          <Calendar id="dataFim" v-model="dataFim" :manualInput="false" class="p-inputMesAno" dateFormat="dd/mm/yy" showIcon />
        </div>
      </div>
      <div class="drops-referencia" v-if="filtroReferencia">
        <div class="field">
          <label for="referencias">Referência</label>
          <Dropdown
            id="referencias"
            :filter="true"
            v-model="referencia"
            :options="dropReferencias?.items"
            placeholder="Selecione a referência"
            optionLabel="referencia"
            @change="referenciaSelecionada($event)"
          />
        </div>
        <div class="field">
          <label for="subperido">Subperíodo</label>
          <Dropdown
            id="subPeriodos"
            :filter="true"
            v-model="subPeriodo"
            :options="dropPeriodos?.items"
            placeholder="Selecione o subperíodo"
            optionLabel="descricao"
            :disabled="loadingSubperiodo"
            @change="subPeriodoSelecionado($event)"
          />
        </div>
      </div>
      <div class="fields-selecao"></div>
    </div>
  </div>
</template>
<style scoped>
.container-filtro-periodo {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  flex-direction: column;
}
.block-perido-filtro {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.troggles-periodo {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.datas-periodo,
.drops-referencia {
  display: flex;
  align-items: center;
  justify-content: start;
}

.field {
  margin-right: 10px;
  display: flex;
  flex-direction: column;

  width: 200px;
}
</style>
